<template>
  <section class="sectionSize bg-secondary">
    <div class="md:grid md:grid-cols-2 gap-8 w-full max-w-3xl mx-auto">

      <div class="flex items-start font-montserrat my-6 mr-10">
        <img src="/heart.svg" alt="" class="h-7 mr-4 flex-shrink-0">
        <div>
          <h3 class="font-semibold text-2xl mb-2">{{ t('lesson.prayer.title') }}</h3>
          <p class="text-gray-600 mb-4">{{ t('lesson.prayer.desc') }}</p>
          <a href="https://t.me/hope365ua_bot" target="_blank" rel="noopener" class="block font-medium hover:underline mb-2">
            → Telegram
          </a>
          <a href="https://wa.me/15557321881" target="_blank" rel="noopener" class="block font-medium hover:underline">
            → WhatsApp
          </a>
        </div>
      </div>

      <div class="flex items-start font-montserrat my-6 mr-10">
        <svg class="h-7 w-7 mr-4 flex-shrink-0" fill="none" stroke="currentColor" stroke-width="1.5" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 6.042A8.967 8.967 0 0 0 6 3.75c-1.052 0-2.062.18-3 .512v14.25A8.987 8.987 0 0 1 6 18c2.305 0 4.408.867 6 2.292m0-14.25a8.966 8.966 0 0 1 6-2.292c1.052 0 2.062.18 3 .512v14.25A8.987 8.987 0 0 0 18 18a8.967 8.967 0 0 0-6 2.292m0-14.25v14.25" />
        </svg>
        <div>
          <h3 class="font-semibold text-2xl mb-2">{{ t('lesson.question.title') }}</h3>
          <p class="text-gray-600 mb-4">{{ t('lesson.question.desc') }}</p>
          <a href="https://t.me/hope365ua_bot" target="_blank" rel="noopener" class="block font-medium hover:underline mb-2">
            → Telegram
          </a>
          <a href="https://wa.me/15557321881" target="_blank" rel="noopener" class="block font-medium hover:underline">
            → WhatsApp
          </a>
        </div>
      </div>

    </div>
  </section>
</template>

<script setup lang="ts">
const { t } = useI18n()
</script>
